"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectUserProfile = void 0;
const base_1 = require("./base");
class IkeObjectUserProfile extends base_1.IkeRestObject {
    constructor() {
        super(...arguments);
        this.className = 'UserProfile';
        this.actionName = 'user.profile';
    }
}
exports.IkeObjectUserProfile = IkeObjectUserProfile;
//# sourceMappingURL=user.profile.object.js.map